module.exports = __webpack_public_path__ + "img/7_143.6167176b.png";